// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  color: #147efe;
}

.card {
  position: relative;
  width: 390px;
  height: 254px;
  background-color: #08163e;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 20px;
  border-radius: 5px;
  cursor: pointer;
  border-color: #147efe;
}
.card:hover {
  box-shadow: 0 0 20px #147efe, 0 0 10px #147efe, 0 0 15px #147efe, 0 0 20px #147efe;
  transition: 0.4s;
  transform: translateY(-3px);
}

.glowing-outline:before, .glowing-outline:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  border: 2px solid #147efe;
  box-shadow: 0 0 10px #147efe, 0 0 5px #147efe, 0 0 8px #147efe, 0 0 10px #147efe;
  opacity: 0;
  transition: 0.5s;
  pointer-events: none;
}

.glowing-outline:before {
  filter: blur(8px);
}

.glowing-outline:hover:before, .glowing-outline:hover:after {
  opacity: 1;
}

.heading {
  font-size: 24px;
  text-transform: capitalize;
  font-weight: 600;
  color: #147efe;
}

.card p:not(.heading) {
  font-size: 16px;
}

.card p:last-child {
  color: #07112e;
  font-weight: 600;
}

.card:hover::after {
  filter: blur(30px);
}

.profile {
  margin-left: auto;
  margin-top: 30px;
  margin-right: 30px;
  cursor: pointer;
}

.btn-style {
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
  color: white;
  padding: 0;
}
.btn-style:hover {
  color: #1a1a86;
  text-shadow: 0 2px 4px rgba(2, 56, 121, 0.5);
}

.btn-open {
  background-color: #0060d6;
  color: white;
  transition: background 0.2s ease-in-out;
}
.btn-open:hover {
  background-color: #00469c;
}

.btn-outline-exit {
  color: #147efe;
  background: transparent;
  border-color: #147efe;
}
.btn-outline-exit:hover {
  color: white;
  background: #00469c;
}

.user-management-btn {
  text-decoration: none;
  color: white;
  font-weight: 500;
  cursor: pointer;
}
.user-management-btn:hover {
  color: #147efe;
}
.user-management-btn:disabled {
  color: #b3b3b3;
  border-radius: 6px;
  cursor: not-allowed;
}

.resources-section {
  background: #1a1a86;
  border-color: #147efe;
}

.resources-item:hover {
  background: #00469c;
  border-color: #ffffff;
  transition: 0.4s;
  cursor: pointer;
}

#dropdownMenuLink:hover {
  color: #147efe !important;
}

a {
  text-decoration: none;
}

.card_desc {
  overflow: hidden;
  line-height: 1.25;
}

mux-player.mux-video {
  height: 300px; /* adjust height as needed */
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
}

.mux-video {
  aspect-ratio: 16/9;
}

.guide-root {
  display: block;
  min-height: 100vh;
  width: 100%;
  background-color: #07112e;
}

.guide-title-glow {
  color: #fff;
  text-align: center;
  animation: glow 1s ease-in-out infinite alternate; /* Apply animation */
}

@keyframes glow {
  from {
    text-shadow: 0 0 8px #fff, 0 0 20px #fff, 0 0 30px #00469c;
  }
  to {
    text-shadow: 0 0 16px #fff, 0 0 30px #147efe, 0 0 40px #147efe;
  }
}
li::marker {
  color: #147efe;
}

:host {
  display: block;
  min-height: 100vh;
  color: #fff;
}

/* The page consumes the shared --ca-* design tokens from styles.scss. */
.products-header {
  position: relative;
  z-index: 5;
  width: 100%;
  background: rgba(7, 17, 46, 0.96);
  border-bottom: 1px solid rgba(185, 205, 242, 0.14);
  box-shadow: 0 8px 28px rgba(1, 8, 23, 0.12);
  backdrop-filter: blur(18px);
}

.products-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  width: min(100%, 1600px);
  min-height: 78px;
  margin: 0 auto;
  padding: 0 clamp(1rem, 4vw, 3.5rem);
}

.brand-lockup,
.header-actions,
.header-action,
.user-management-btn {
  display: inline-flex;
  align-items: center;
}

.brand-lockup {
  flex: 0 1 auto;
  gap: 1rem;
  min-width: 0;
}

.brand-lockup__logo {
  display: block;
  width: auto;
  max-width: 160px;
  height: 38px;
  object-fit: contain;
}

.brand-lockup__divider,
.header-actions__divider {
  width: 1px;
  height: 28px;
  background: rgba(220, 229, 245, 0.22);
}

.brand-lockup__caption {
  color: #aabbd9;
  font-size: 0.67rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  white-space: nowrap;
}

.header-actions {
  justify-content: flex-end;
  gap: clamp(0.6rem, 1.5vw, 1.35rem);
  min-width: 0;
}

.header-action {
  gap: 0.55rem;
  padding: 0.7rem 0.25rem;
  color: #d7e2f5;
  font-size: 0.86rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: color 180ms ease;
}

.header-action:hover,
.header-action:focus-visible {
  color: #fff;
}

.header-action > .fa:first-child {
  color: #8eaff4;
  font-size: 0.95rem;
}

.resources-dropdown .dropdown-toggle::after {
  margin-left: 0.25rem;
  vertical-align: 0.15em;
}

.resources-menu {
  min-width: 220px;
  margin-top: 0.65rem;
  padding: 0.45rem;
  background: #0c1e45;
  border: 1px solid rgba(167, 192, 239, 0.2);
  border-radius: var(--ca-radius-md, 8px);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.3);
}

.resources-menu__item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 0.8rem;
  color: #d7e2f5;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-size: 0.86rem;
  text-align: left;
  cursor: pointer;
}

.resources-menu__item > .fa:first-child {
  width: 18px;
  color: #8eaff4;
  text-align: center;
}

.resources-menu__item:hover,
.resources-menu__item:focus-visible {
  color: #fff;
  background: rgba(40, 80, 173, 0.3);
}

.resources-menu__external {
  margin-left: auto;
  color: #8eaff4;
  font-size: 0.72rem;
}

.user-management-btn {
  justify-content: center;
  gap: 0.6rem;
  min-height: 40px;
  padding: 0.62rem 0.95rem;
  color: #eff5ff;
  background: rgba(40, 80, 173, 0.18);
  border: 1px solid rgba(126, 164, 235, 0.35);
  border-radius: var(--ca-radius-sm, 6px);
  font: inherit;
  font-size: 0.83rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 180ms ease, border-color 180ms ease, transform 180ms ease;
}

.user-management-btn > .fa {
  color: #a9c4ff;
}

.user-management-btn:not(:disabled):hover {
  background: rgba(40, 80, 173, 0.38);
  border-color: rgba(169, 196, 255, 0.65);
  transform: translateY(-1px);
}

.user-management-btn:disabled {
  color: #8a98b1;
  background: rgba(255, 255, 255, 0.035);
  border-color: rgba(255, 255, 255, 0.08);
  cursor: not-allowed;
  opacity: 0.72;
}

.user-management-btn:disabled > .fa {
  color: #8795af;
}

.profile-slot {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/guide/guide.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;EAGC,YAAA;EACA,aAAA;EACD,yBAAA;EACA,aAAA;EACA,sBAAA;EACC,uBAAA;EACD,iBAAA;EAIA,kBAAA;EACA,eAAA;EACA,qBAAA;AAJF;AAME;EACE,kFAAA;EACA,gBAAA;EACA,2BAAA;AAJJ;;AASA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gFAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;AANF;;AAUC;EACC,iBAAA;AAPF;;AAWC;EACC,UAAA;AARF;;AAYA;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAaA;EACE,cAAA;EACA,gBAAA;AAVF;;AAaA;EACE,kBAAA;AAVF;;AAmBA;EAEE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;AAjBF;AAmBE;EACE,cAAA;EACA,4CAAA;AAjBJ;;AAgCE;EACA,yBAAA;EACA,YAAA;EACA,uCAAA;AA7BF;AA+BE;EACG,yBAAA;AA7BL;;AAiCG;EACD,cAAA;EACA,uBAAA;EACA,qBAAA;AA9BF;AAgCE;EACE,YAAA;EACA,mBAAA;AA9BJ;;AAmCA;EACE,qBAAA;EACA,YAAA;EAEA,gBAAA;EACA,eAAA;AAjCF;AAmCE;EACE,cAAA;AAjCJ;AAoCE;EACE,cAAA;EAEA,kBAAA;EACA,mBAAA;AAnCJ;;AAuCE;EACC,mBAAA;EACA,qBAAA;AApCH;;AA0CK;EACD,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAvCJ;;AA4CM;EACD,yBAAA;AAzCL;;AA+CE;EACE,qBAAA;AA5CJ;;AA+CE;EACK,gBAAA;EAEA,iBAAA;AA7CP;;AAiDE;EACA,aAAA,EAAA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AA9CF;;AAiDA;EACE,kBAAA;AA9CF;;AAiDA;EACE,cAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AA9CF;;AAiDA;EACE,WAAA;EACA,kBAAA;EACA,iDAAA,EAAA,oBAAA;AA9CF;;AAiDA;EACE;IACE,0DAAA;EA9CF;EAgDA;IACE,8DAAA;EA9CF;AACF;AAiDA;EACE,cAAA;AA/CF;;AA8EA;EACE,cAAA;EACA,iBAAA;EACA,WAAA;AA3EF;;AA8EA,wEAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iCAAA;EACA,kDAAA;EACA,2CAAA;EAEA,2BAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;AA3EF;;AA8EA;;;;EAIE,oBAAA;EACA,mBAAA;AA3EF;;AA8EA;EACE,cAAA;EACA,SAAA;EACA,YAAA;AA3EF;;AA8EA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AA3EF;;AA8EA;;EAEE,UAAA;EACA,YAAA;EACA,qCAAA;AA3EF;;AA8EA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AA3EF;;AA8EA;EACE,yBAAA;EACA,kCAAA;EACA,YAAA;AA3EF;;AA8EA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,4BAAA;AA3EF;;AA8EA;;EAEE,WAAA;AA3EF;;AA8EA;EACE,cAAA;EACA,kBAAA;AA3EF;;AA8EA;EACE,oBAAA;EACA,sBAAA;AA3EF;;AA8EA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,uCAAA;EACA,0CAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,cAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA3EF;;AA8EA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;AA3EF;;AA8EA;;EAEE,WAAA;EACA,kCAAA;AA3EF;;AA8EA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AA3EF;;AA8EA;EACE,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,mCAAA;EACA,2CAAA;EACA,uCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sFAAA;AA3EF;;AA8EA;EACE,cAAA;AA3EF;;AA8EA;EACE,mCAAA;EACA,uCAAA;EACA,2BAAA;AA3EF;;AA8EA;EACE,cAAA;EACA,sCAAA;EACA,uCAAA;EACA,mBAAA;EACA,aAAA;AA3EF;;AA8EA;EACE,cAAA;AA3EF;;AA8EA;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;AA3EF","sourcesContent":[".title{\n  color: #147efe;\n}\n\n.card {\n  position: relative;\n  // width: 190px;\n  // height: 254px;\n   width: 390px;\n   height: 254px;\n  background-color: #08163e;\n  display: flex;\n  flex-direction: column;\n   justify-content: center;\n  padding: 0px 20px;\n  // gap: 5px;\n  // letter-spacing: 0.1em;\n  //line-height: 1.3;\n  border-radius: 5px;\n  cursor: pointer;\n  border-color: #147efe;\n   \n  &:hover{\n    box-shadow: 0 0 20px #147efe, 0 0 10px #147efe, 0 0 15px #147efe, 0 0 20px #147efe;\n    transition: 0.4s;\n    transform: translateY(-3px);\n  }\n}\n\n\n.glowing-outline:before, .glowing-outline:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n  border: 2px solid #147efe;\n  box-shadow: 0 0 10px #147efe, 0 0 5px #147efe, 0 0 8px #147efe, 0 0 10px #147efe;\n  opacity: 0;\n  transition: 0.5s;\n  pointer-events: none;\n }\n \n \n .glowing-outline:before {\n  filter: blur(8px);\n }\n \n \n .glowing-outline:hover:before, .glowing-outline:hover:after {\n  opacity: 1;\n }\n\n\n.heading {\n  font-size: 24px;\n  text-transform: capitalize;\n  font-weight: 600;\n  color: #147efe;\n}\n\n.card p:not(.heading) {\n  font-size: 16px;\n\n}\n\n.card p:last-child {\n  color: #07112e;\n  font-weight: 600;\n}\n\n.card:hover::after {\n  filter: blur(30px);\n  \n}\n\n// .card:hover::before {\n//   transform: rotate(-90deg) scaleX(0.66) scaleY(1.52);\n// }\n\n\n.profile{\n  //margin-left:auto;\n  margin-left:auto;\n  margin-top: 30px;\n  margin-right: 30px;\n  cursor: pointer;\n}\n\n.btn-style {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font: inherit;\n  color: white;\n  padding: 0;\n\n  &:hover {\n    color: #1a1a86;\n    text-shadow: 0 2px 4px rgba(2, 56, 121, 0.5);\n  }\n\n}\n\n// .btn-submit {\n//   background-color: #0060d6;\n//   color: #ffff;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// .btn-submit:hover {\n//   background-color: #1a1a86;\n// }\n\n  .btn-open {\n  background-color: #0060d6;\n  color: #ffff;\n  transition: background 0.2s ease-in-out;\n\n  &:hover{\n     background-color: #00469c;\n  }\n}\n\n   .btn-outline-exit{\n  color: #147efe;                 // text / border color\n  background: transparent;\n  border-color: #147efe;\n\n  &:hover{\n    color: white;\n    background: #00469c;\n\n  }\n  }\n\n.user-management-btn {\n  text-decoration: none;\n  color: white;\n  //  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n\n  &:hover {\n    color: #147efe;\n  }\n\n  &:disabled {\n    color: #b3b3b3;          // lighter grey text\n   // background-color: #f5f5f5; // subtle grey background\n    border-radius: 6px;      // optional: give disabled a boxed look\n    cursor: not-allowed;\n  }\n}\n\n  .resources-section{\n   background:#1a1a86;\n   border-color:#147efe\n\n  \n  }\n\n  .resources-item{\n     &:hover{\n    background:#00469c;\n    border-color:#ffffff;\n    transition: 0.4s;\n    cursor: pointer;\n   }\n  }\n\n  #dropdownMenuLink{\n      &:hover{\n     color: #147efe !important;\n  }\n  }\n\n\n\n  a{\n    text-decoration: none;\n  }\n\n  .card_desc{\n       overflow: hidden;\n      // text-align: justify;\n       line-height: 1.25;\n  }\n\n\n  mux-player.mux-video {\n  height: 300px; /* adjust height as needed */\n  background-color: #000;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.mux-video {\n  aspect-ratio: 16/9;\n}\n\n.guide-root{\n  display: block;\n  min-height: 100vh;\n  width: 100%;\n  background-color: #07112e;\n}\n\n.guide-title-glow {\n  color: #fff;\n  text-align: center;\n  animation: glow 1s ease-in-out infinite alternate; /* Apply animation */\n}\n\n@keyframes glow {\n  from {\n    text-shadow: 0 0 8px #fff, 0 0 20px #fff, 0 0 30px #00469c;\n  }\n  to {\n    text-shadow: 0 0 16px #fff, 0 0 30px #147efe, 0 0 40px #147efe;\n  }\n}\n\nli::marker {\n  color: #147efe;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n:host {\n  display: block;\n  min-height: 100vh;\n  color: #fff;\n}\n\n/* The page consumes the shared --ca-* design tokens from styles.scss. */\n.products-header {\n  position: relative;\n  z-index: 5;\n  width: 100%;\n  background: rgba(7, 17, 46, 0.96);\n  border-bottom: 1px solid rgba(185, 205, 242, 0.14);\n  box-shadow: 0 8px 28px rgba(1, 8, 23, 0.12);\n  -webkit-backdrop-filter: blur(18px);\n  backdrop-filter: blur(18px);\n}\n\n.products-header__inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  width: min(100%, 1600px);\n  min-height: 78px;\n  margin: 0 auto;\n  padding: 0 clamp(1rem, 4vw, 3.5rem);\n}\n\n.brand-lockup,\n.header-actions,\n.header-action,\n.user-management-btn {\n  display: inline-flex;\n  align-items: center;\n}\n\n.brand-lockup {\n  flex: 0 1 auto;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.brand-lockup__logo {\n  display: block;\n  width: auto;\n  max-width: 160px;\n  height: 38px;\n  object-fit: contain;\n}\n\n.brand-lockup__divider,\n.header-actions__divider {\n  width: 1px;\n  height: 28px;\n  background: rgba(220, 229, 245, 0.22);\n}\n\n.brand-lockup__caption {\n  color: #aabbd9;\n  font-size: 0.67rem;\n  font-weight: 700;\n  letter-spacing: 0.13em;\n  white-space: nowrap;\n}\n\n.header-actions {\n  justify-content: flex-end;\n  gap: clamp(0.6rem, 1.5vw, 1.35rem);\n  min-width: 0;\n}\n\n.header-action {\n  gap: 0.55rem;\n  padding: 0.7rem 0.25rem;\n  color: #d7e2f5;\n  font-size: 0.86rem;\n  font-weight: 500;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 180ms ease;\n}\n\n.header-action:hover,\n.header-action:focus-visible {\n  color: #fff;\n}\n\n.header-action > .fa:first-child {\n  color: #8eaff4;\n  font-size: 0.95rem;\n}\n\n.resources-dropdown .dropdown-toggle::after {\n  margin-left: 0.25rem;\n  vertical-align: 0.15em;\n}\n\n.resources-menu {\n  min-width: 220px;\n  margin-top: 0.65rem;\n  padding: 0.45rem;\n  background: #0c1e45;\n  border: 1px solid rgba(167, 192, 239, 0.2);\n  border-radius: var(--ca-radius-md, 8px);\n  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.3);\n}\n\n.resources-menu__item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.75rem 0.8rem;\n  color: #d7e2f5;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  font-size: 0.86rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.resources-menu__item > .fa:first-child {\n  width: 18px;\n  color: #8eaff4;\n  text-align: center;\n}\n\n.resources-menu__item:hover,\n.resources-menu__item:focus-visible {\n  color: #fff;\n  background: rgba(40, 80, 173, 0.3);\n}\n\n.resources-menu__external {\n  margin-left: auto;\n  color: #8eaff4;\n  font-size: 0.72rem;\n}\n\n.user-management-btn {\n  justify-content: center;\n  gap: 0.6rem;\n  min-height: 40px;\n  padding: 0.62rem 0.95rem;\n  color: #eff5ff;\n  background: rgba(40, 80, 173, 0.18);\n  border: 1px solid rgba(126, 164, 235, 0.35);\n  border-radius: var(--ca-radius-sm, 6px);\n  font: inherit;\n  font-size: 0.83rem;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 180ms ease, border-color 180ms ease, transform 180ms ease;\n}\n\n.user-management-btn > .fa {\n  color: #a9c4ff;\n}\n\n.user-management-btn:not(:disabled):hover {\n  background: rgba(40, 80, 173, 0.38);\n  border-color: rgba(169, 196, 255, 0.65);\n  transform: translateY(-1px);\n}\n\n.user-management-btn:disabled {\n  color: #8a98b1;\n  background: rgba(255, 255, 255, 0.035);\n  border-color: rgba(255, 255, 255, 0.08);\n  cursor: not-allowed;\n  opacity: 0.72;\n}\n\n.user-management-btn:disabled > .fa {\n  color: #8795af;\n}\n\n.profile-slot {\n  display: inline-flex;\n  align-items: center;\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
